import styled from 'styled-components/macro';
import {
  fontSize,
  layout,
  lineHeight,
  media,
  space,
} from '../../../theme/tokens';

export const PrivacyContainer = styled.div`
  max-width: ${layout.readableMaxWidth};
  margin: 0 auto;
  padding: ${space[5]} ${layout.gutter} ${space[7]};
  font-size: ${fontSize.md};
  line-height: ${lineHeight.normal};
  color: ${({ theme }) => theme.headerColour};
  overflow-wrap: anywhere;

  ${media.md`
    padding: ${space[7]} ${layout.gutterWide};
  `}
`;

export const PolicyText = styled.p`
  white-space: pre-line;
  overflow-wrap: anywhere;
  font-size: ${fontSize.md};
  line-height: ${lineHeight.normal};
  color: ${({ theme }) => theme.headerColour};
`;
